export const buildSelectorFromTipoTelefoneResponse = response => response.map(data => ({
  id: data.idTipoTelefone,
  value: data.nomeTipoTelefone,
}));
